import { render, staticRenderFns } from "./ProfileStart.vue?vue&type=template&id=594dc807&"
import script from "./ProfileStart.vue?vue&type=script&lang=js&"
export * from "./ProfileStart.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStart.vue?vue&type=style&index=0&id=594dc807&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports